module.exports = __webpack_public_path__ + "static/media/3.5aa575e8.jpg";